import { useQuery } from '@tanstack/react-query';
import { regionalComparisonsApi } from '@/features/reports/api/regionalComparisons.api';

export type RegionalComparisonsQueryFilters = {
  year: number | null;
  governorateIds?: string[];
  cityIds?: string[];
  areaIds?: string[];
};

export const regionalComparisonsQueryKeys = {
  all: ['regional-comparisons'] as const,
  report: (f: RegionalComparisonsQueryFilters) =>
    [
      ...regionalComparisonsQueryKeys.all,
      'report',
      f.year ?? 0,
      [...(f.governorateIds ?? [])].sort().join('\0'),
      [...(f.cityIds ?? [])].sort().join('\0'),
      [...(f.areaIds ?? [])].sort().join('\0'),
    ] as const,
};

export function useRegionalComparisonsQuery(filters: RegionalComparisonsQueryFilters) {
  const enabled =
    filters.year != null && Number.isFinite(filters.year) && filters.year > 0;

  return useQuery({
    queryKey: regionalComparisonsQueryKeys.report(filters),
    queryFn: () =>
      regionalComparisonsApi.getReport({
        year: filters.year!,
        governorateIds: filters.governorateIds,
        cityIds: filters.cityIds,
        areaIds: filters.areaIds,
      }),
    enabled,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
